// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--NHcXd";
export var icons = "footer-module--icons--vgXyR";
export var item = "footer-module--item--F8w8q";
export var items = "footer-module--items--I9ZyN";
export var list = "footer-module--list--d7bwp";
export var privacyOpen = "footer-module--privacy-open--L3FZm";
export var privacyPopupLink = "footer-module--privacy-popup-link--dTS4u";